export default "__VITE_ASSET__G0UywYvM__"